import { Endpoints, generateAxios } from '@matap/shared';
import { generateQuery } from './create-hooks';

export const useVerifyDiscount = generateQuery(Endpoints.discounts.user.verify, (endpoint, payload) => ({
  queryKey: ['useVerifyDiscount', payload.query],
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
}));
